(() => {
  const ready = (callback) => document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', callback, { once: true })
    : callback();

  function bindDesktopMenus(root = document) {
    root.querySelectorAll('.sil-nav-dropdown').forEach((item) => {
      if (item.dataset.silMenuBound) return;
      item.dataset.silMenuBound = 'true';
      let closeTimer;
      const open = () => {
        clearTimeout(closeTimer);
        item.classList.remove('is-escape-closed');
        item.classList.add('is-open');
        item.querySelector(':scope > a')?.setAttribute('aria-expanded', 'true');
      };
      const close = () => {
        clearTimeout(closeTimer);
        closeTimer = setTimeout(() => {
          if (!item.matches(':hover') && !item.contains(document.activeElement)) {
            item.classList.remove('is-open');
            item.querySelector(':scope > a')?.setAttribute('aria-expanded', 'false');
          }
        }, 240);
      };
      item.addEventListener('pointerenter', open);
      item.addEventListener('pointerleave', close);
      item.addEventListener('focusin', open);
      item.addEventListener('focusout', close);
      item.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          item.classList.remove('is-open');
          item.classList.add('is-escape-closed');
          item.querySelector(':scope > a')?.setAttribute('aria-expanded', 'false');
          item.querySelector(':scope > a')?.focus();
        }
      });
    });
  }

  function bindFallbackDrawers(root = document) {
    root.querySelectorAll('header-drawer, menu-drawer').forEach((drawer) => {
      if (drawer.dataset.silFallbackBound || drawer.constructor !== HTMLElement) return;
      drawer.dataset.silFallbackBound = 'true';
      const main = drawer.querySelector(':scope > details');
      const summary = main?.querySelector(':scope > summary');
      if (!main || !summary) return;
      const sync = () => {
        main.classList.toggle('menu-opening', main.open);
        summary.setAttribute('aria-expanded', String(main.open));
        document.documentElement.classList.toggle('overflow-hidden-mobile', main.open);
      };
      summary.addEventListener('click', () => requestAnimationFrame(sync));
      main.addEventListener('toggle', sync);
      drawer.querySelectorAll('.menu-drawer__close-button').forEach((button) => {
        button.addEventListener('click', () => {
          const details = button.closest('details');
          if (details) details.open = false;
        });
      });
    });
  }

  function bindFallbackSliders(root = document) {
    root.querySelectorAll('slider-component').forEach((component) => {
      if (component.dataset.silFallbackBound || component.constructor !== HTMLElement || component.classList.contains('sil-product-gallery')) return;
      const track = component.querySelector('[id^="Slider-"]');
      const prev = component.querySelector('button[name="previous"]');
      const next = component.querySelector('button[name="next"]');
      if (!track || !prev || !next) return;
      component.dataset.silFallbackBound = 'true';
      const move = (direction) => {
        const items = [...track.children].filter((item) => item.getBoundingClientRect().width > 0);
        if (!items.length) return;
        const step = items[1] ? items[1].offsetLeft - items[0].offsetLeft : track.clientWidth;
        track.scrollTo({ left: track.scrollLeft + direction * step, behavior: 'smooth' });
      };
      prev.addEventListener('click', (event) => { event.preventDefault(); move(-1); });
      next.addEventListener('click', (event) => { event.preventDefault(); move(1); });
    });
  }

  function bindFallbackQuantities(root = document) {
    root.querySelectorAll('quantity-input').forEach((quantity) => {
      if (quantity.dataset.silFallbackBound || quantity.constructor !== HTMLElement) return;
      const input = quantity.querySelector('input[type="number"]');
      if (!input) return;
      quantity.dataset.silFallbackBound = 'true';
      quantity.querySelectorAll('button').forEach((button) => button.addEventListener('click', (event) => {
        event.preventDefault();
        const delta = /minus|decrease/i.test(button.name || button.getAttribute('aria-label') || '') ? -1 : 1;
        const min = Number(input.min || 1); const max = Number(input.max || Infinity); const step = Number(input.step || 1);
        input.value = String(Math.max(min, Math.min(max, Number(input.value || min) + delta * step)));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }));
    });
  }

  ready(() => {
    bindDesktopMenus();
    bindFallbackDrawers();
    bindFallbackSliders();
    bindFallbackQuantities();
    document.addEventListener('shopify:section:load', (event) => {
      bindDesktopMenus(event.target); bindFallbackDrawers(event.target); bindFallbackSliders(event.target); bindFallbackQuantities(event.target);
    });
  });
})();
